import InputVaultSelect from 'structure/capital-manager/components/InputVaultSelect';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { DynaVault } from '../../../api/DynaVaultsAPI';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { canDepositIntoVault } from 'structure/pv2/vault/utils/canDepositIntoVault';

interface ZapNowProps {
  className?: string;
  depositTokenAddress: `0x${string}`;
  vaultList: DynaVault[];
  onZap: (params: {
    depositTokenAddress: `0x${string}`;
    vault: DynaVault;
  }) => void;
}

export const ZapNow = (props: ZapNowProps) => {
  const { className, depositTokenAddress, vaultList, onZap } = props;

  const [vault, setVault] = useState<DynaVault | null>(vaultList[0] ?? null);

  useEffect(
    function initVault() {
      if (vaultList.length === 0) {
        setVault(null);
        return;
      }

      const selectedVaultIsAvailable = vaultList.some(
        (availableVault) =>
          availableVault.chainId === vault?.chainId &&
          availableVault.address.toLowerCase() === vault.address.toLowerCase()
      );

      if (!vault || !selectedVaultIsAvailable) {
        setVault(vaultList[0]);
        return;
      }
    },
    [vaultList, vault]
  );

  const handleClickZap = (tokenAddress: `0x${string}`) => {
    if (!vault || !canDepositIntoVault(vault)) {
      // Handle case when no vault is selected, e.g., show an error message
      console.error('Please select an open vault before zapping.');
      return;
    }

    onZap({
      depositTokenAddress: tokenAddress,
      vault,
    });
  };

  if (vaultList.length === 0 || !vault) {
    return null;
  }

  return (
    <div className={twMerge('flex flex-row items-center gap-4', className)}>
      <InputVaultSelect
        options={vaultList}
        name={`vault-[${depositTokenAddress}]`}
        value={vault}
        onChange={(address: string) => {
          setVault(
            vaultList.find(
              (v) =>
                v.chainId === vault.chainId &&
                v.address.toLowerCase() === address.toLowerCase()
            ) || vaultList[0]
          );
        }}
      />

      <Button
        className='inline-flex shrink-0 items-center gap-2 text-[1.125rem] lg:text-[1rem]'
        disabled={!canDepositIntoVault(vault)}
        onClick={() => handleClickZap(depositTokenAddress)}
      >
        Zap Now
      </Button>
    </div>
  );
};
